module.exports = __webpack_public_path__ + "img/Indium-Logo.a0a8619c.png";